import __request__ from "routing/request";
export function getAll() {
  return __request__("GET", "/system/indexer/indices/templates", null, {}, {
    "Accept": ["application/json"]
  });
}
export function syncAll() {
  return __request__("POST", "/system/indexer/indices/templates/update", null, {}, {
    "Accept": ["application/json"]
  });
}
export function get(indexSetId) {
  return __request__("GET", `/system/indexer/indices/templates/${indexSetId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function sync(indexSetId) {
  return __request__("POST", `/system/indexer/indices/templates/${indexSetId}/update`, null, {}, {
    "Accept": ["application/json"]
  });
}
